<template>
  <div class="conserve-wrapper">
    <div class="nav" style="height: auto">
      <div class="nav-left">
        <div
          class="parallelogram-btn-left parallelogram-btn-active"
          style="margin-right: 0.5vw"
        >
          <div class="icon-font">&#xe63f;</div>
          <div>养护计划单</div>
        </div>
        <div class="parallelogram-btn-left" @click="toDueSummery">
          <div class="icon-font">&#xe63f;</div>
          <div>养护到期汇总</div>
        </div>
      </div>
      <div class="nav-center">养护计划单列表</div>
      <div class="nav-right">
        <div
          class="parallelogram-btn-right"
          :class="change === 1 ? className : ''"
          style="margin-right: 0.5vw"
        ></div>
        <div
          class="parallelogram-btn-right"
          :class="change === 2 ? className : ''"
          style="margin-right: 0.5vw"
        ></div>
        <div
          class="parallelogram-btn-right"
          :class="change === 3 ? className : ''"
          style="margin-right: 0.5vw"
        ></div>
        <div
          class="parallelogram-btn-right"
          :class="change === 4 ? className : ''"
          style="margin-right: 0.5vw"
        ></div>
        <div
          class="parallelogram-btn-right"
          :class="change === 5 ? className : ''"
          style="margin-right: 0.5vw"
        ></div>
        <div class="parallelogram-btn-right" @click="exportData">
          <div class="icon-font">&#xe601;</div>
          <div>导出表格</div>
        </div>
      </div>
    </div>
    <transition name="slide-fade">
      <div class="inspection-cen">
        <div class="warn-top" style="display: flex;
  flex-direction: column;">
          <div class="top-select">
            <div style="margin-right: 0.7vw">
              <DropDown
                :content="warehouseTitle"
                :items="warehouse"
                @sendInfo="showInfoW"
              ></DropDown>
            </div>
            <div style="margin-right: 0.7vw">
              <DropDown
                message="请选择仓库"
                :content="buildingTitle"
                :items="building"
                @sendInfo="showInfoB"
              ></DropDown>
            </div>
            <div style="margin-right: 0.7vw">
              <DropDown
                message="请选择楼号"
                :content="floorTitle"
                :items="floor"
                @sendInfo="showInfoF"
              ></DropDown>
            </div>
            <div style="margin-right: 0.7vw">
              <DropDown
                message="请选择层号"
                :content="areaTitle"
                :items="area"
                @sendInfo="showInfoA"
              ></DropDown>
            </div>
            <div class="input-wrapper">
              <input disabled="true" v-model="stackTitle" placeholder="" />
            </div>
             <div style="margin-left: 0.7vw">
              <DropDown
                content="请选择养护阶段"
                :items="maintainStageData"
                v-on:sendInfo="showInfoMaintainStag"
              ></DropDown>
            </div>
          </div>
          <div class="top-crib" style="margin-top:10px;">
            <div
              style="display: flex; flex-direction: row; align-items: center"
            >
              <div class="top-crib-title">垛位：</div>
              <div
                class="top-crib-title-num"
                :class="{ 'top-crib-title-num-active': data.sign === 1 }"
                v-for="(data, index) in stack"
                v-if="index < 5"
                :key="index"
                @click="changeBg(index)"
              >
                {{ data.name }}
              </div>
              <div class="no-stack" v-if="stack.length === 0">暂无垛位</div>
              <div
                class="top-crib-more"
                v-if="stack.length > 5"
                @click="showCribMore = true"
              >
                更多
              </div>
              
            </div>
          </div>
          <div class="top-select" style="margin-top:20px;">
            <div class="input-date-wrapper">
              <el-date-picker
                v-model="value"
                type="daterange"
                value-format="yyyy-MM-dd"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
              >
              </el-date-picker>
            </div>
           
            <div class="input-wrapper">
              <input v-model="keyword" placeholder="请输入批次号或烟叶简称" />
            </div>
            <div
              class="query"
              style="margin-left: 1vw"
              @click="handleSearch(1)"
            >
              查询
            </div>
            
          </div>
        </div>
        <div class="inspection-operation">
          <div class="two-font-wrapper" @click="toNewSingle">
            <div class="icon-font">&#xe605;</div>
            新建
          </div>
          <div class="two-font-wrapper" @click="deleteAll">
            <div class="icon-font">&#xe646;</div>
            删除
          </div>
        </div>
        <div class="detail">
          <div class="detail-box">
            <div class="loading-data" v-if="loading">
              <i class="el-icon-loading"></i>
              <div>加载中，请稍后···</div>
            </div>
            <div class="detail-nav">
              <div class="detail-item" style="width: 5%">
                <div
                  class="select-icon"
                  :class="{ 'select-icon-active': all }"
                  @click="selectAll"
                ></div>
              </div>
              <div class="detail-item" style="width: 5%">序号</div>
              <div class="detail-item" style="width: 10%">批次号</div>
              <div class="detail-item" style="width: 15%">烟叶简称</div>
              <div class="detail-item" style="width: 10%">养护阶段</div>
              <div class="detail-item" style="width: 20%">位置</div>
              <div class="detail-item" style="width: 15%">计划养护时间</div>
              <div class="detail-item" style="width: 20%">操作</div>
            </div>
            <div class="detail-content">
              <div
                class="detail-list-wrapper"
                v-if="!loading && tableData.length > 0"
                v-for="(data, index) in tableData"
                :key="index"
              >
                <div class="detail-item" style="width: 5%">
                  <div
                    class="select-icon"
                    :class="{ 'select-icon-active': data.sign === 1 }"
                    @click="selectSingle(data.id)"
                  ></div>
                </div>
                <div class="detail-item" style="width: 5%">{{ index + 1 }}</div>
                <div class="detail-item" style="width: 10%">
                  {{ data.materialBatchNum }}
                </div>
                <div class="detail-item" style="width: 15%">
                  {{ data.materialName }}
                </div>
                <div class="detail-item" style="width: 10%">
                  {{ getMaintainStageData(data.maintainStage) }}
                </div>
                <div
                  class="detail-item"
                  style="width: 20%"
                >
                  {{ data.siteName }}
                </div>
                <div class="detail-item" style="width: 15%">
                  {{ data.maintainDays }}
                </div>
      
                <div class="detail-item" style="width: 20%">
                  <div
                    class="detail-btn item-look"
                    @click="toSingleLook(data.id)"
                    v-if="data.approveStatus === 0"
                  >
                    查看
                  </div>
                  <div
                    class="detail-btn item-audit-active"
                    @click="toSingleLook(data.id)"
                    v-if="data.approveStatus === 1 || data.approveStatus === 2"
                  >
                    查看
                  </div>
                  <div
                    class="detail-btn item-audit"
                    @click="toSingleApproval(data.id)"
                    style="margin: 0 0.5vw"
                    v-if="data.approveStatus === 0"
                  >
                    审核
                  </div>
                  <div
                    class="detail-btn item-audit item-audit-active"
                    style="margin: 0 0.5vw"
                    v-if="data.approveStatus === 1 || data.approveStatus === 2"
                  >
                    审核
                  </div>
                  <div
                    class="detail-btn item-delete"
                    @click="deleteSingle(data.id)"
                  >
                    删除
                  </div>
                </div>
              </div>
              <div class="none-data" v-if="!loading && tableData.length < 1">
                暂无数据
              </div>
            </div>
            <div class="page-wrapper" v-if="!loading && total > rows">
              <div class="page-wrapper-left">
                共{{ total }}条数据，每页显示{{ rows }}条，当前第{{ page }}页
              </div>
              <div class="page-wrapper-right">
                <div class="page-btn" @click="firstPage">首页</div>
                <div class="page-btn" @click="previousPage">上一页</div>
                <div class="page-btn" @click="nextPage">下一页</div>
                <div class="page-btn" @click="lastPage">尾页</div>
              </div>
            </div>
          </div>
          <transition name="fade">
            <div class="alert-box" v-if="show">
              <div class="alert-content">
                <div class="alert-content-title">删除提醒</div>
                <div class="alert-content-msg">是否确认删除选中数据?</div>
                <div class="alert-content-btn">
                  <div class="btn-cancel button" @click="cancelDelete">
                    取消
                  </div>
                  <div class="btn-confirm button" @click="confirmDelete">
                    确认
                  </div>
                </div>
              </div>
            </div>
          </transition>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import click from "../../../tools/click";
import DropDown from "../../../components/DropDownSingle.vue";
import { exportJson } from "../../../vendor/Export2Excel";
import { warehouseNode } from "../../../api/basic";
import {
  queryMaintainPlan,
  delMaintainPlan,
  bathDelMaintainPlan,
  exportMaintainPlan,
} from "../../../api/maintain";
export default {
  name: "PlanSingle",
  components: { DropDown },
  data() {
    return {
      className: "parallelogram-btn-right_",
      change: 0,
      value: "",
      show: false,
      all: false,
      id: "",
      type: 0,
      idList: [],
      approveStatusData: [
        { name: "全部", value: "" },
        { name: "未审核", value: 0 },
        { name: "已审核", value: 1 },
        { name: "已拒绝", value: 2 },
      ],
      maintainStageData: [
        { name: "全部", value: "" },
        { name: "自然醇化阶段", value: "01" },
        { name: "防霉杀虫阶段", value: "02" },
        { name: "气调醇化阶段", value: "03" },
        { name: "气调保质阶段", value: "04" },
      ],
      loading: true,
      keyword: "",
      approveStatus: "",
      maintainStage: "",
      startTime: "",
      endTime: "",
      page: 1,
      rows: 5,
      total: "",
      warehouse: [],
      building: [],
      floor: [],
      area: [],
      stack: [],
      tableData: [],
      warehouseTitle: "请选择仓库",
      buildingTitle: "请选择楼号",
      floorTitle: "请选择层号",
      areaTitle: "请选择区号",
      stackTitle: "请选择垛位",
      siteId: "",
      siteType: "",
    };
  },
  created() {
    let body = {
      warehouseNodeId: '',
      warehouseNodeType: '01'
    }
    warehouseNode(body).then(res => {
      console.log(res)
      this.warehouse = res.data
    }).catch(err => {
      console.log(err)
    })
    this.handleSearch(1);
    let _this = this;
    let a = 1;
    setInterval(function () {
      _this.change = a;
      a++;
      if (a === 6) {
        a = 1;
      }
    }, 1000);
    let b = 0;
    setInterval(function () {
      b++;
      if (b < 6) {
        _this.className = "parallelogram-btn-right_";
      } else if (b < 11) {
        _this.className = "parallelogram-btn-right__";
      } else if (b < 16) {
        _this.className = "parallelogram-btn-right___";
      } else {
        b = 1;
        _this.className = "parallelogram-btn-right_";
      }
    }, 1000);
  },
  watch: {
    value: function () {
      console.log(this.value);
      this.startTime = this.value !== null ? this.value[0] : "";
      this.endTime = this.value !== null ? this.value[1] : "";
    },
  },
  methods: {
    getMaintainStageData: function (maintainStage) {
      if (maintainStage === "01") {
        return "自然醇化阶段";
      } else if (maintainStage === "02") {
        return "防霉杀虫阶段";
      } else if (maintainStage === "03") {
        return "气调醇化阶段";
      } else {
        return "气调保质阶段";
      }
    },
    getApproveStatus: function (approveStatus) {
      if (approveStatus === 0) {
        return "未审核";
      } else if (approveStatus === 1) {
        return "已审核";
      } else if (approveStatus === 2) {
        return "已拒绝";
      }
    },
    toDueSummery: function () {
      this.$router.push({
        path: "/conserve/dueSummery",
        query: {
          index: "8",
        },
      });
    },
    toSingleLook: function (id) {
      this.$router.push({
        path: "/conserve/singleLook",
        query: {
          index: "8",
          id: id,
        },
      });
    },
    toSingleApproval: function (id) {
      this.$router.push({
        path: "/conserve/singleApproval",
        query: {
          index: "8",
          id: id,
        },
      });
    },
    toNewSingle: function () {
      this.$router.push({
        path: "/conserve/singleNew",
        query: {
          index: "8",
        },
      });
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map((v) => filterVal.map((j) => v[j]));
    },
    exportData: function () {
      let body = {
        keyword: this.keyword,
        approveStatus: this.approveStatus,
        maintainStage: this.maintainStage,
        startTime: this.startTime,
        endTime: this.endTime,
      };
      exportMaintainPlan(body)
        .then((res) => {
          console.log(res);
          res.data.map((data) => {
            data.maintainStage = this.getMaintainStageData(data.maintainStage);
            data.approveStatus = this.getApproveStatus(data.approveStatus);
          });
          require.ensure([], () => {
            const tHeader = [
              "批次号",
              "烟叶简称",
              "养护阶段",
              "位置",
              "计划养护时间",
              "审核状态",
            ];
            const filterVal = [
              "materialBatchNum",
              "materialName",
              "maintainStage",
              "siteName",
              "maintainDays",
              "approveStatus",
            ];
            const list = res.data;
            const data = this.formatJson(filterVal, list);
            exportJson(tHeader, data, "养护计划单列表");
            this.$message({
              message: "导出成功!",
              type: "success",
              center: "true",
              duration: 1000,
            });
          });
        })
        .catch((err) => {
          console.log(err);
          this.$message({
            message: "导出失败!",
            type: "warning",
            center: "true",
            duration: 1000,
          });
        });
    },
    showInfoStatus: function (data) {
      this.approveStatus = data.value;
    },
    showInfoMaintainStag: function (data) {
      this.maintainStage = data.value;
    },
    handleSearch: function (type) {
      if (type === 1) {
        this.page = 1;
      }
      let body = {
        page: this.page,
        rows: this.rows,
        keyword: this.keyword,
        approveStatus: this.approveStatus,
        maintainStage: this.maintainStage,
        startTime: this.startTime,
        endTime: this.endTime,
        siteId: this.siteId,
        siteType: this.siteType,
      };
      this.loading = true;
      queryMaintainPlan(body)
        .then((res) => {
          console.log(res);
          res.data.rows &&
            res.data.rows.map((item) => {
              item.sign = 0;
            });
          this.tableData = res.data.rows || [];
          this.total = res.data.total;
          this.loading = false;
          this.all = false;
          this.idList = [];
        })
        .catch((err) => {
          console.log(err);
        });
    },
    selectAll: function () {
      this.type = 1;
      this.all = !this.all;
      let idList = [];
      if (this.all) {
        this.tableData.map((data, index) => {
          data.sign = 1;
          idList.push(data.id);
        });
        this.idList = idList;
      } else {
        this.tableData.map((data, index) => {
          data.sign = 0;
          this.idList = [];
        });
      }
    },
    selectSingle: function (id) {
      this.tableData.map((data, index) => {
        if (id === data.id) {
          data.sign = data.sign === 1 ? 0 : 1;
          if (data.sign === 1) {
            this.idList.push(data.id);
          } else {
            let idList = [];
            this.idList.map((item, index) => {
              if (item !== id) {
                idList.push(item);
              }
            });
            this.idList = idList;
          }
          console.log(this.idList);
        }
      });
      this.all = this.idList.length === this.tableData.length;
    },
    deleteSingle: function (id) {
      this.show = true;
      this.id = id;
      this.type = 0;
    },
    deleteAll: function () {
      if (this.idList.length !== 0) {
        this.show = true;
        this.type = 1;
      } else {
        this.$message({
          message: "请选择要删除的数据!",
          type: "warning",
          center: "true",
          duration: "1000",
        });
      }
      console.log(this.idList);
    },
    cancelDelete: function () {
      this.show = false;
    },
    confirmDelete: function () {
      if (this.type === 0) {
        console.log(this.id);
        let body = {
          id: this.id,
        };
        delMaintainPlan(body)
          .then((res) => {
            console.log(res);
            if (res.code === 200) {
              this.$message({
                message: res.data,
                type: "success",
                center: "true",
                duration: "1000",
              });
              this.show = false;
              this.handleSearch();
            } else {
              this.$message({
                message: res.message,
                type: "warning",
                center: "true",
                duration: "1000",
              });
              this.show = false;
              this.handleSearch();
            }
          })
          .catch((err) => {
            console.log(err);
          });
      } else {
        console.log(this.idList);
        let body = {
          idArray: this.idList.join(),
        };
        bathDelMaintainPlan(body)
          .then((res) => {
            console.log(res);
            if (res.code === 200) {
              this.$message({
                message: res.data,
                type: "success",
                center: "true",
                duration: "1000",
              });
              this.show = false;
              this.handleSearch();
            } else {
              this.$message({
                message: res.message,
                type: "warning",
                center: "true",
                duration: "1000",
              });
              this.show = false;
              this.handleSearch();
            }
          })
          .catch((err) => {
            console.log(err);
          });
      }
    },
    firstPage: function () {
      console.log("首页");
      if (this.page === 1) {
        this.$message({
          message: "当前为第一页",
          type: "warning",
          center: "true",
          duration: "1000",
        });
      } else {
        this.page = 1;
        this.handleSearch();
      }
    },
    previousPage: function () {
      console.log("上一页");
      if (this.page < 2) {
        this.$message({
          message: "当前为第一页",
          type: "warning",
          center: "true",
          duration: "1000",
        });
      } else {
        this.page--;
        this.handleSearch();
      }
    },
    nextPage: function () {
      console.log("下一页");
      if (parseInt(this.total / this.rows) + 1 > this.page) {
        this.page++;
        this.handleSearch();
      } else {
        this.$message({
          message: "当前为最后一页",
          type: "warning",
          center: "true",
          duration: "1000",
        });
      }
    },
    lastPage: function () {
      console.log("尾页");
      if (this.page === parseInt(this.total / this.rows) + 1) {
        this.$message({
          message: "当前为最后一页",
          type: "warning",
          center: "true",
          duration: "1000",
        });
      } else {
        if (Math.round(this.total % this.rows) === 0) {
          this.page = parseInt(this.total / this.rows);
        } else {
          this.page = parseInt(this.total / this.rows) + 1;
        }
        this.handleSearch();
      }
    },
    showInfoB: function (data) {
      this.buildingTitle = data.name;
      this.siteId = data.id;
      this.siteType = data.siteType;
      let body = {
        warehouseNodeId: data.id,
        warehouseNodeType: "03",
      };
      warehouseNode(body)
        .then((res) => {
          console.log(res);
          this.floor = res.data;
          this.floorTitle = "请选择层号";
          this.area = [];
          this.areaTitle = "请选择区号";
          this.stack = [];
          this.stackTitle = "请选择垛位";
        })
        .catch((err) => {
          console.log(err);
        });
    },
    showInfoF: function (data) {
      this.floorTitle = data.name;
      this.siteId = data.id;
      this.siteType = data.siteType;
      let body = {
        warehouseNodeId: data.id,
        warehouseNodeType: "04",
      };
      warehouseNode(body)
        .then((res) => {
          console.log(res);
          this.area = res.data;
          this.areaTitle = "请选择区号";
          this.stack = [];
          this.stackTitle = "请选择垛位";
        })
        .catch((err) => {
          console.log(err);
        });
    },
    showInfoA: function (data) {
      this.areaTitle = data.name;
      this.siteId = data.id;
      this.siteType = data.siteType;
      let body = {
        warehouseNodeId: data.id,
        warehouseNodeType: "05",
      };
      warehouseNode(body)
        .then((res) => {
          console.log(res);
          res.data.map((item) => {
            item.sign = 0;
          });
          this.stack = res.data;
          this.stackTitle = "请选择垛位";
        })
        .catch((err) => {
          console.log(err);
        });
    },
    changeBg: function (index) {
      this.stack.map((data, ind) => {
        if (index === ind) {
          data.sign = 1;
          this.stackTitle = data.name;
          this.siteId = data.id;
          this.siteType = data.siteType;
        } else {
          data.sign = 0;
        }
      });
      this.showCribMore = false;
    },
    showInfoW: function (data) {
      this.warehouseTitle = data.name;
      this.siteId = data.id;
      this.siteType = data.siteType;
      let body = {
        warehouseNodeId: data.id,
        warehouseNodeType: "02",
      };
      warehouseNode(body)
        .then((res) => {
          console.log(res);
          this.building = res.data;
          this.buildingTitle = "请选择楼号";
          this.floor = [];
          this.floorTitle = "请选择层号";
          this.area = [];
          this.areaTitle = "请选择区号";
          this.stack = [];
          this.stackTitle = "请选择垛位";
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>

<style scoped>
@import "Conserve.css";
</style>



// WEBPACK FOOTER //
// src/page/maintain/conserve/PlanSingle.vue